import { IStorageState } from '@adex/shared/models/states/storage.state'
import { SyncStorage } from 'ngx-webstorage'
import { map, tap } from 'rxjs/operators'
import { isUndefined } from '@adex/shared/utils/data'


const initialState: IStorageState = {
  personalization: {
    isCollapsedMenu: false,
    autoRefreshPostAnalysisReport: true
  }
}


export class StorageStateCreator {
  private static readonly keys: (keyof IStorageState)[] = [ 'user', 'personalization' ]

  public static create(): IStorageState {
    const state: IStorageState = { ...initialState }
    for (let i = 0; i < this.keys.length; i++) {
      const key = this.keys[i]
      const value = state[key]
      state[key] = value as any || null
    }
    return state
  }

  public static init(ls: SyncStorage, changeStateFn: (key: any, value: any) => void): IStorageState {
    const state: IStorageState = { ...initialState }
    for (let i = 0; i < this.keys.length; i++) {
      const key = this.keys[i]
      const value = state[key]
      state[key] = ls.retrieve(key) || value as any || null
      ls.observe(key).pipe(
        map(newValue => isUndefined(newValue) ? null : newValue),
        tap(newValue => changeStateFn(key, newValue))
      ).subscribe()
    }
    return state
  }

}
